module.exports = __webpack_public_path__ + "static/media/NotoSans-BoldItalic.fa53cf9b.woff";